/* Đo đường khách đi trong quiz — mở trang, từng màn, từng câu trả lời, tới lúc bấm mua.
 *
 * CỐ Ý NẰM NGOÀI `quiz-inner-weather.js`. ĐỪNG GỘP VÀO.
 * File kia được bê nguyên từ minespirit-quiz.pages.dev và đã bị THAY TRỌN GÓI một lần
 * (commit 63a7ff1 · 03/09: 21.846 -> 28.983 dòng). Vá nằm trong nó là mất sạch, im lặng.
 * `quiz-goi-api.js` sống qua đúng lần thay đó mà không phải sửa một ký tự — vì nó chỉ bọc
 * hàm theo TÊN và đọc `state`. File này đi cùng một đường.
 *
 * Ngược lại, `quiz-sang-trang-ban.js` phải vá hai lần trong bốn tiếng sau cùng lần thay đó.
 * Khác nhau đúng một điểm: file kia với tay vào OUTPUT ĐÃ RENDER (selector `.dsec.b4hit`,
 * so chuỗi `'$9.99'`). Nên ở đây: chỉ đọc `state`, `SCREENS`, `cur`, `QUIZ7`, và bọc hàm
 * theo tên. Không querySelector theo class. Không so chuỗi hiển thị. Không đọc innerHTML.
 * Ngoại lệ DUY NHẤT là listener nút mua ở cuối file — click đó rời khỏi tài liệu, không có
 * đường nào khác bắt được — và nó bám ID, thứ `quiz-sang-trang-ban.js:309` đã coi là hợp
 * đồng ổn định.
 *
 * Hỏng thì IM LẶNG. Không bao giờ được làm vỡ quiz hay chặn luồng mua: thà mất số còn hơn
 * mất đơn. Mọi thứ chạm vào quiz đều nằm trong try/catch.
 */
(function () {
  var goc = document.getElementById('phone');
  if (!goc) return;

  /* Theme editor mở trang quiz như khách thật và origin của nó nằm trong allowlist, nên
     mỗi lần marketer chỉnh customizer là một lượt giả nằm lẫn trong `quiz_attempts` —
     không có cột nào để lọc ra sau. Bail ở đây, giống các asset khác trong theme. */
  if (window.Shopify && window.Shopify.designMode) return;

  if (typeof SCREENS === 'undefined' || typeof goto !== 'function') return;

  /* `minespirit_luot` là HỢP ĐỒNG GIỮA HAI FILE: `quiz-goi-api.js` đọc khoá này để gắn
     `attempt_id` vào `/api/quiz/submit`. Đổi tên ở một đầu là cắt đường nối "ai đã mua"
     mà không lỗi nào báo.
     KHÔNG đụng `minespirit_phien`. Khoá đó gánh việc nối đơn hàng ↔ phiên; trộn vào là
     hỏng cả hai. */
  var KHOA_LUOT = 'minespirit_luot';
  var DANG_UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

  /* `goto` KHÔNG đổi `cur` ngay: nó hẹn `setTimeout(…, 180)` rồi mới gán `cur` và dựng màn
     (`quiz-inner-weather.js:9028-9051`). Đọc `cur` ngay sau khi gọi hàm gốc là đọc phải màn
     CŨ — mọi `screen_viewed` lệch một nhịp mà không lỗi nào báo. Nên đọc TRỄ hơn nhịp đó. */
  var TRE_GOTO = 220;

  var luot = '';
  var manCuoi = -1, dungGoto0 = false, henMan = null;
  var giaObserver = null, giaTimer = null, giaScr = null, giaCard = null;
  var giaScroll = null, giaDaCuon = false, giaDaThay = false;
  var hooksGan = [];

  /* ── Mã lượt ────────────────────────────────────────────────────────────────
     MINT MỚI MỖI LẦN NẠP TRANG, trừ MỘT trường hợp: khách tải lại cùng tab khi đang ở màn
     36/37. Khi đó `quiz-bo-de-dung-man.js` đưa khách về đúng màn đó và đặt
     `window.__msTiepLuot` = mã lượt cũ — lượt này đi tiếp (xem `tiepLuot()`), vì đồng hồ
     giữ giá và mã phiên đều gắn với mã lượt.
     Đi tiếp thì `seq` cũng phải đi tiếp: dùng lại id cũ mà `seq` về 0 là mọi event sau đó
     trùng `(attempt_id, seq)` và bị máy chủ nuốt sạch bằng `ignoreDuplicates`, không lỗi nào
     báo. Nên `day()` cất `seq` kế tiếp vào `KHOA_SEQ` theo từng lượt. */
  function uuid() {
    try { if (window.crypto && crypto.randomUUID) return crypto.randomUUID(); } catch (e) {}
    var b = new Array(16), i;
    try {
      if (window.crypto && crypto.getRandomValues) {
        var r = new Uint8Array(16);
        crypto.getRandomValues(r);
        for (i = 0; i < 16; i++) b[i] = r[i];
      }
    } catch (e) {}
    for (i = 0; i < 16; i++) if (b[i] === undefined) b[i] = (Math.random() * 256) | 0;
    b[6] = (b[6] & 0x0f) | 0x40;
    b[8] = (b[8] & 0x3f) | 0x80;
    var h = '';
    for (i = 0; i < 16; i++) {
      h += (b[i] + 0x100).toString(16).slice(1);
      if (i === 3 || i === 5 || i === 7 || i === 9) h += '-';
    }
    return h;
  }

  function luotMoi() {
    dungTheoDoiGia();
    luot = uuid();
    manCuoi = -1;
    giaDaThay = false;
    try { sessionStorage.setItem(KHOA_LUOT, luot); } catch (e) {}
    day({ event: 'tracker_ready' });
  }

  /* Đi tiếp lượt cũ sau khi tải lại. Trả `false` khi không có gì để đi tiếp. */
  function tiepLuot() {
    var cu = window.__msTiepLuot;
    if (typeof cu !== 'string' || !DANG_UUID.test(cu)) return false;
    luot = cu;
    manCuoi = -1;
    giaDaThay = false;
    return true;
  }

  /* ── Dấu vân tay cấu trúc màn ───────────────────────────────────────────────
     Đây là thứ làm việc hỏng NHÌN THẤY ĐƯỢC. Bọc theo tên thì đổi tên là hỏng im lặng —
     không ngăn được, chỉ phát hiện được: quiz đổi cấu trúc màn thì `screens_hash` đổi ngay
     ở lượt đầu tiên, hook rơi thì thiếu tên trong `hooks_attached`.

     Băm bằng một hàm ngắn tự viết chứ không dùng `crypto.subtle`: cái đó bất đồng bộ, kéo
     cả đường khởi động thành promise chỉ để lấy một dấu vân tay không cần chống va chạm
     chủ ý. FNV-1a (8 hex) nối bốn hex thấp của djb2 = 12 hex. */
  function bam(s) {
    var a = 0x811c9dc5, b = 5381, i, c;
    for (i = 0; i < s.length; i++) {
      c = s.charCodeAt(i);
      a = (((a ^ c) >>> 0) * 16777619) >>> 0;
      b = (((b << 5) >>> 0) + b + c) >>> 0;
    }
    return ('00000000' + a.toString(16)).slice(-8) + ('0000' + (b & 0xffff).toString(16)).slice(-4);
  }



  function manCoThat(t) {
    for (var i = 0; i < SCREENS.length; i++) if (SCREENS[i].t === t) return true;
    return false;
  }

  /* Tính ở LẦN FLUSH ĐẦU, không lúc nạp file. `boot()` đã gỡ `seasons` xong trước khi file
     này chạy, nên hôm nay hai thời điểm cho cùng kết quả — nhưng `SCREENS` bị dựng lại ở
     bảy chỗ khác nhau trong engine, và thứ tự đó đã đổi bốn lần trong hai tuần. Tính muộn
     là đọc mảng ở trạng thái khách thật sự thấy. Đây chính là cái chuông báo hỏng; chốt
     sớm một `screens_hash` sai là làm hỏng luôn cả chuông. */
  function dauVanTay() {
    var ten = [], hooks = hooksGan.slice(), i;
    for (i = 0; i < SCREENS.length; i++) ten.push(SCREENS[i].t);
    for (i = 0; i < MAN_NHAP.length; i++) if (manCoThat(MAN_NHAP[i])) hooks.push(MAN_NHAP[i]);
    return { screens_count: SCREENS.length, screens_hash: bam(ten.join(',')), hooks: hooks };
  }

  /* Tracker first-party của storefront (`beat.js`, thẻ `msTrack` ở `layout/quiz.liquid`).
     Mỗi event mang `attempt_id` = `luot` đang giữ trong biến: `beat.js` ưu tiên mã này và
     chỉ đọc `minespirit_luot` khi thiếu.
     Tracker chưa về thì `msTrack` là hàng đợi; chưa có `msTrack` (tracker bị gỡ khỏi
     layout) thì im lặng, quiz vẫn chạy. */
  function msGhi(ten, thuoc) {
    if (luot) thuoc.attempt_id = luot;
    try { if (typeof window.msTrack === 'function') window.msTrack(ten, thuoc); } catch (e) {}
  }

  /* Tên event bên `beat.js` mang tiền tố `quiz_`. Bốn tên dưới đây đổi hẳn; tên còn lại
     chỉ thêm tiền tố (`submit_ok` → `quiz_submit_ok`). Tên máy chủ chưa biết thì nó bỏ
     riêng event đó, không lỗi. */
  var TEN_BEAT = { tracker_ready: 'quiz_ready', screen_viewed: 'quiz_screen',
                   answered: 'quiz_answered', buy_clicked: 'quiz_buy' };

  /* `day()` chuyển event sang `msTrack`.
     Chỉ chép ĐÚNG các khoá máy chủ nhận, không chép cả object: event từ `__msSuKien` mang
     thêm đủ thứ (`plan`, `price`). `value` — thứ khách gõ hoặc chọn, có thể là email — chỉ
     đi kèm `answered`: máy chủ tách nó ra bảng riêng, không bao giờ để trong dòng phễu. */
  function day(ev) {
    if (!luot) return;
    try {
      var ten = String(ev.event || ''), thuoc = {}, dau;
      if (!ten) return;
      if (ev.screen) thuoc.screen = ev.screen;
      if (ev.question_id) thuoc.question_id = ev.question_id;
      if (ev.button) thuoc.button = ev.button;
      if (ten === 'answered' && !giaTriRong(ev.value)) thuoc.value = ev.value;
      if (ten === 'screen_viewed' && typeof cur === 'number') thuoc.index = cur;
      if (ten === 'tracker_ready') {
        dau = dauVanTay();
        thuoc.screens_count = dau.screens_count;
        thuoc.screens_hash = dau.screens_hash;
        thuoc.hooks = dau.hooks;
        if (window.__msBoDe) thuoc.set_version = String(window.__msBoDe);
      }
      msGhi(TEN_BEAT[ten] || (ten.indexOf('quiz_') === 0 ? ten : 'quiz_' + ten), thuoc);
    } catch (e) {}
  }

  /* ── Thẻ giá đã thật sự được nhìn thấy ─────────────────────────────────────
     `a7pc1` là thẻ giá đầu của phase 25, còn `#scr` mới là vùng cuộn thật của quiz.
     Không tính lần dựng màn đầu: khách phải cuộn trong `#scr` trước, rồi giữ ít nhất
     50% thẻ trong khung nhìn một giây. Cờ và observer đều sống theo lượt làm bài. */
  function tiLeTrongKhung() {
    if (!giaCard || !giaScr) return 0;
    var r, k, cao, tren, duoi;
    try {
      r = giaCard.getBoundingClientRect();
      k = giaScr.getBoundingClientRect();
      cao = r.height || (r.bottom - r.top);
      if (!cao) return 0;
      tren = Math.max(r.top, k.top);
      duoi = Math.min(r.bottom, k.bottom);
      return Math.max(0, duoi - tren) / cao;
    } catch (e) { return 0; }
  }

  function dungGiaTimer() {
    if (giaTimer) { clearTimeout(giaTimer); giaTimer = null; }
  }

  function dungTheoDoiGia() {
    dungGiaTimer();
    try { if (giaObserver) giaObserver.disconnect(); } catch (e) {}
    if (giaScr && giaScroll) {
      try { giaScr.removeEventListener('scroll', giaScroll); } catch (e) {}
    }
    giaObserver = null;
    giaScr = null;
    giaCard = null;
    giaScroll = null;
    giaDaCuon = false;
  }

  function kiemTraGia() {
    if (giaDaThay || !giaDaCuon || !giaCard || !giaScr ||
        !SCREENS[cur] || SCREENS[cur].t !== 'gd1off') {
      dungGiaTimer();
      return;
    }
    if (tiLeTrongKhung() < 0.5) {
      dungGiaTimer();
      return;
    }
    if (giaTimer) return;
    giaTimer = setTimeout(function () {
      giaTimer = null;
      if (giaDaThay || !giaDaCuon || tiLeTrongKhung() < 0.5 ||
          !SCREENS[cur] || SCREENS[cur].t !== 'gd1off') return;
      giaDaThay = true;
      var ev = { event: 'price_seen', screen: SCREENS[cur].t };
      /* Giá THẬT khách thấy lúc đó ($4.90 hay $19 sau khi hết giờ giữ giá). */
      try {
        if (typeof window.__msGoiHienTai === 'function') ev.price = window.__msGoiHienTai().so;
      } catch (e) {}
      day(ev);
    }, 1000);
  }

  function batDauTheoDoiGia() {
    dungTheoDoiGia();
    if (giaDaThay || typeof IntersectionObserver !== 'function') return;
    var scr = document.getElementById('scr');
    var card = document.getElementById('a7pc1');
    if (!scr || !card) return;
    giaScr = scr;
    giaCard = card;
    giaScroll = function () {
      giaDaCuon = true;
      kiemTraGia();
    };
    scr.addEventListener('scroll', giaScroll, { passive: true });
    giaObserver = new IntersectionObserver(function () { kiemTraGia(); }, {
      root: scr,
      threshold: [0, 0.5]
    });
    giaObserver.observe(card);
    /* Callback đầu tiên bị bỏ qua vì `giaDaCuon` vẫn false. */
    kiemTraGia();
  }

  /* ── Màn nào là màn khách vừa trả lời ───────────────────────────────────────
     Rời một màn trong danh sách này theo chiều ĐI TỚI nghĩa là khách vừa trả lời xong: quiz
     không có đường nào khác đi tới. `multi7` chỉ đi tới ở nút Continue (bấm tick chạy nhiều
     lần mỗi màn nhưng không rời màn); `q7duo` đi tới khi đã chọn đủ. Nhờ đọc theo hướng đi
     mà `answered` bắt được mà không phải sờ vào một nút nào trong DOM — `q7duo` vốn KHÔNG có
     nút Continue, muốn bọc handler của nó thì buộc phải bám class `.pill`.

     KIỂM TÊN MÀN CÓ TRONG `SCREENS`, KHÔNG KIỂM RENDERER CÓ TỒN TẠI. `RENDER.q`,
     `RENDER.multi`, `RENDER.home` đều còn sống và qua được mọi `typeof` guard, nhưng không
     màn nào mang `t` đó nữa sau khi `v10Screens` dựng lại `SCREENS`. Ở đây danh sách được
     đối chiếu với `SCREENS` lúc chạy, nên tên chết tự rụng.

     `social` KHÔNG có trong danh sách: màn đó chỉ là tường bằng chứng xã hội với một nút
     "Next", không nhận gì của khách (`quiz-inner-weather.js:11946`). */
  var MAN_NHAP = ['q7duo', 'multi7', 'pick7', 'bdate', 'btime', 'bplace', 'name', 'email'];

  /* Khoá câu hỏi lấy từ CHÍNH bảng của quiz — `QUIZ7.questions[q].id` là khoá quiz dùng để
     lưu câu trả lời (`state.q7[id]`), không phải bảng tra do file này bịa ra. Gửi thẳng chỉ
     số `items[].q` mới là bịa: thứ tự màn đã đổi bốn lần trong hai tuần. */
  function idCauHoi(s) {
    var ra = [], i, it, Q;
    try {
      if (s.t === 'q7duo' && s.items) {
        for (i = 0; i < s.items.length; i++) {
          it = s.items[i];
          Q = (it.q !== undefined) ? QUIZ7.questions[it.q] : QUIZ7[it.p];
          if (Q && Q.id) ra.push(Q.id);
          else if (it.p) ra.push(it.p);
        }
      } else if (s.t === 'multi7' && QUIZ7.multi && QUIZ7.multi[s.mi]) {
        ra.push(QUIZ7.multi[s.mi].id);
      } else if (s.t === 'pick7' && s.src) {
        ra.push((QUIZ7[s.src] && QUIZ7[s.src].id) || s.src);
      }
    } catch (e) {}
    return ra;
  }

  /* undefined / null / chuỗi rỗng → không gắn `value`. Số 0 là đáp án hợp lệ (ô đầu). */
  function giaTriRong(v) {
    return v === undefined || v === null || v === '';
  }

  function layGiaTri(qid, t) {
    try {
      if (!state) return;
      if (t === 'q7duo' || t === 'pick7' || t === 'multi7') return state.q7 ? state.q7[qid] : undefined;
      if (t === 'bdate') return (state.bdate && state.bdate.raw) || undefined;
      if (t === 'btime') return state.btime;
      if (t === 'bplace') return state.bplace;
      if (t === 'name') return state.name;
      if (t === 'email') return state.email;
    } catch (e) {}
  }

  function ghiTraLoi(i) {
    var s = SCREENS[i];
    if (!s || MAN_NHAP.indexOf(s.t) === -1) return;
    var ids = idCauHoi(s), j, ev, v;
    if (ids.length) {
      for (j = 0; j < ids.length; j++) {
        ev = { event: 'answered', screen: s.t, question_id: ids[j] };
        v = layGiaTri(ids[j], s.t);
        if (!giaTriRong(v)) ev.value = v;
        day(ev);
      }
      return;
    }
    /* Màn nhập tự do. `btime` có nhánh SKIP riêng — nút "I don't know" ghi đúng chuỗi rỗng
       vào `state.btime` (`:21545`), và nút Continue thì không bao giờ để nó rỗng. */
    var qid = s.t;
    if (s.t === 'btime' && !state.btime) qid = 'btime_skip';
    /* Từ 08/09/2026 màn ngày sinh có nút Skip ngang hàng Continue, và bỏ qua là một tín
       hiệu bán hàng thật: khối lợi ích ẩn bốn dòng thuộc Bản đồ. Phải phân biệt được
       "bỏ qua" với "chưa tới màn" trong số. */
    if (s.t === 'bdate' && !(state.bdate && state.bdate.raw)) qid = 'bdate_skip';
    ev = { event: 'answered', screen: s.t, question_id: qid };
    v = layGiaTri(qid, s.t);
    if (!giaTriRong(v)) ev.value = v;
    day(ev);
  }

  /* Đọc màn THẬT SỰ tới, không đọc tham số của `goto`: `v9qSkipWake` (`:23486`) có thể
     chuyển hướng `goto(i)` sang `goto(j)` khi màn đích đã chết. So với `manCuoi` để khử
     trùng — hai lần `goto` chồng nhau chỉ dựng một màn, nên chỉ được sinh một event. */
  function ghiManHinh() {
    if (typeof cur !== 'number' || cur === manCuoi) return;
    var truoc = manCuoi;
    manCuoi = cur;
    if (dungGoto0 && truoc > 0 && cur === 0) { luotMoi(); manCuoi = cur; }
    else if (truoc > -1 && cur > truoc) {
      /* Rời `intro` đi tới là khách BẮT ĐẦU làm bài, không phải trả lời gì cả — đó là mẫu
         số của cả phễu. Ba màn tin cậy (`credibility`, `expert`, `social`) cũng không nhận
         gì của khách, nên chúng chỉ có `screen_viewed`.
         Đi LÙI thì không bao giờ bắn `answered`. Lùi rồi đi tới lại thì `answered` bắn lần
         nữa với `seq` mới — trả lời lại là tín hiệu thật, gộp trùng là việc của câu SQL. */
      if (SCREENS[truoc] && SCREENS[truoc].t === 'intro') day({ event: 'quiz_started', screen: 'intro' });
      else ghiTraLoi(truoc);
    }
    var s = SCREENS[cur];
    if (s) {
      day({ event: 'screen_viewed', screen: s.t });
      if (s.t === 'gd1off') batDauTheoDoiGia();
      else dungTheoDoiGia();
    } else {
      dungTheoDoiGia();
    }
  }

  /* ── Hook chính: `goto` ─────────────────────────────────────────────────────
     `goto` chỉ bị gán lại đúng một lần trong 29k dòng (`v9qSkipWake`, forward sạch), và mọi
     điều hướng — kể cả nút back — đều đi qua nó. */
  var goto_goc = goto;
  goto = function () {
    /* ĐÚNG MỘT hẹn giờ đang chờ, y như `navTimer` của quiz — `goto` tự huỷ hẹn cũ khi bị
       gọi đè. Điều hướng nhanh liên tiếp mà mỗi lần đẻ một hẹn giờ là ghi ra một chuỗi màn
       ma: chỉ màn cuối được dựng thật. */
    try {
      if (henMan) clearTimeout(henMan);
      henMan = setTimeout(function () { henMan = null; ghiManHinh(); }, TRE_GOTO);
    } catch (e) {}
    return goto_goc.apply(this, arguments);
  };
  hooksGan.push('goto');

  /* ── Start over ─────────────────────────────────────────────────────────────
     Bốn chỗ trong quiz đều làm `state = freshState(); goto(0);` (`:8935 :10118 :10148
     :10582`). Bọc `freshState` chứ KHÔNG đoán qua `goto(0)`: nút back cũng gọi `goto(0)`
     khi đang ở màn 1, đoán kiểu đó là đẻ lượt ma. Flush lượt cũ trước khi đổi id, không thì
     những event còn trong đệm chết theo. */
  if (typeof freshState === 'function') {
    var fs_goc = freshState;
    freshState = function () {
      try { luotMoi(); } catch (e) {}
      return fs_goc.apply(this, arguments);
    };
    hooksGan.push('freshState');
  } else {
    dungGoto0 = true;
    hooksGan.push('goto0');
  }

  /* ── Nút mua ────────────────────────────────────────────────────────────────
     Bản v7.9 có ba nút của màn giá: `a7buy`, `a7buy2`, `a7stkbuy`. Giữ thêm ba ID
     cũ để lượt v3.1 còn trong cache không mất số. Capture phase vì handler của đường
     mua gọi `stopPropagation()`; gửi ngay vì `muaNgay()` điều hướng sang checkout. */
  document.addEventListener('click', function (e) {
    try {
      var n = e.target && e.target.closest && e.target.closest(
        '#gd1-buy,#a7buy,#a7buy2,#a7stkbuy,#buy,#buy2,#cdgo');
      if (!n) return;
      var dau = window.__msMuaClickDuocChapNhan === n;
      if (n.disabled && !dau) return;
      if (typeof window.__msMuaDangChay === 'function' &&
          window.__msMuaDangChay() && !dau) return;
      if (typeof window.__msMuaNgay !== 'function' &&
          typeof window.__msSangTrangBan !== 'function') return;
      day({ event: 'buy_clicked',
        screen: (SCREENS[cur] && SCREENS[cur].t) || '',
        button: n.id || '' });
    } catch (er) {}
  }, true);
  hooksGan.push('buy');

  /* Kênh cho `quiz-giai-doan-1.js` gửi sáu event của mục 4.9 (`result_view`, `cta_click`,
     `offer_view`, `plan_select`, `checkout_start`, `checkout_done`).

     VÌ SAO PHƠI `day()` RA CHỨ KHÔNG ĐỂ FILE KIA TỰ GỬI: `attempt_id` và `seq` phải là MỘT
     dãy cho cả lượt. File kia tự mint lượt riêng thì máy chủ thấy hai `quiz_attempts` cho
     cùng một khách, và phễu "xem kết quả → bấm mua" không join lại được.
     Cùng lý do với `minespirit_luot` mà `quiz-goi-api.js` đang đọc.

     `day()` đã tự bỏ qua khi chưa có lượt hoặc quá `TRAN_SEQ`, và mọi đường gửi đều nằm
     trong try/catch — nên kênh này không thể làm vỡ quiz. Endpoint không từ chối event lạ. */
  window.__msSuKien = function (ev) {
    try { if (ev && typeof ev === 'object' && ev.event) day(ev); } catch (e) {}
  };

  /* Đi tiếp lượt cũ thì KHÔNG ghi màn đang hiện lúc nạp (màn chào, chỉ đứng đó vài nhịp
     trước khi overlay đưa khách về màn 36/37): ghi nó là lượt đó có thêm một `screen_viewed`
     ở `intro`, rồi lần đi tới màn 36/37 bị đọc thành `quiz_started` lần hai. */
  var diTiep = tiepLuot();
  if (!diTiep) luotMoi();

  /* Vào thẳng bằng `?screen=`, và cả lần dựng màn đầu của mọi lượt: quiz gọi `boot()` ngay
     lúc nạp `quiz-inner-weather.js`, tức TRƯỚC khi file này chạy — bản bọc `goto` ở trên
     không ăn lần đó. Đúng khuôn `quiz-goi-api.js:266-271`. */
  if (!diTiep) { try { ghiManHinh(); } catch (e) {} }
})();
